import { config } from '@/config';
import { ConnectButton } from '@/features/canva/components/ConnectButton';
import { useCanvaIntegrations } from '@/features/canva/hooks/useIntegrations';
import {
  Alert,
  AlertIcon,
  AlertTitle,
  Box,
  Divider,
  Flex,
  Heading,
  Link,
  Spinner,
  Text,
} from '@/ui';
import { Benefits } from './Benefits';
import { IntegrationList } from './IntegrationList';

export const IntegrationsSection = () => {
  const {
    data: integrations = [],
    error,
    isPending: isLoading,
  } = useCanvaIntegrations();

  const isError = Boolean(error);

  return (
    <Box as="section">
      {integrations.length > 0 ? (
        <>
          <Heading as="h3" fontWeight="600" mb="3" size="sm">
            Connected integration
          </Heading>
          <IntegrationList integrations={integrations} />
        </>
      ) : isLoading ? (
        <Flex align="center" gap="2">
          <Spinner size="sm" /> Loading integration...
        </Flex>
      ) : isError ? (
        <Alert status="error">
          <AlertIcon />
          <AlertTitle>
            Whoops! We had some trouble looking up your Canva integrations.
            Please try again.
          </AlertTitle>
        </Alert>
      ) : (
        <>
          <Benefits mb="4" />
          <ConnectButton launch="settings:integrations" />
        </>
      )}

      <Divider my="6" />

      <Text color="customgray.mid" fontSize="sm">
        Need help with your Canva integration?{' '}
        <Link href={`mailto:${config.supportEmail}`}>Contact support</Link>.
      </Text>
    </Box>
  );
};
